import React from 'react';
import ApplicationsInstancesTableView from '../../views/applications/instances';
import { withRouter } from 'react-router-dom';
import { AppCollection } from '../../services/collection';
import CurrentApplicationLabel from "./current-label";

class ApplicationsInstancesTableScreen extends React.Component {


  getApps() {
    return this.props.match.params.uuid ? (
      (this.props.apps || [])
        .filter(({ uuid }) => this.props.match.params.uuid === uuid)
    ) : (this.props.apps || []);
  }

  getInstances() {
    return this.getApps()
      .reduce(
        (instances, app) => instances.concat(
          (app.instances || [])
            .map(instance => ({
              ...app,
              ...instance,
              app
            }))
        ),
        []
      );
  }

  render() {
    return (
      <ApplicationsInstancesTableView
        name={(
          <React.Fragment>
            <CurrentApplicationLabel />&nbsp;Instances
          </React.Fragment>
        )}
        products={this.getInstances()}
      />
    )
  }
}

const mapAppProps = ({ loading, list }) => ({ apps: list, appsLoading: loading });

const appConnect = AppCollection.connect(mapAppProps);

export default appConnect(
  withRouter(ApplicationsInstancesTableScreen)
);



// WEBPACK FOOTER //
// ./src/app/applications/instances.js